import { Box, Button, Typography } from '@mui/material';

import { useAuth } from 'src/routes/Auth/authContext';

const UserNotExist = () => {
  const { logout } = useAuth();
  return (
    <>
      <Box>
        <Typography variant="h3" sx={{ mb: 2 }}>
          User does not exist
        </Typography>
        <Typography variant="body1" color="text.secondary">
          The email address you’ve used to log in is not associated with a user in Received Digital. Please contact your
          administrator to get set up.
        </Typography>
      </Box>

      <Box>
        <img
          src="/images/illustration_authentication.png"
          alt="Authentication error"
          style={{ padding: '40px 67px 80px' }}
        />

        <Button variant="contained" size="large" color="primary" onClick={() => logout()}>
          Return to Login
        </Button>
      </Box>
    </>
  );
};

export default UserNotExist;
